module.exports = __webpack_public_path__ + "static/img/setingu2.fe3f47c6.png";